
import { defineComponent, ref, reactive, toRefs, onMounted, computed, onUnmounted, watch } from 'vue'
import { InfoCircleOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtopF10.vue'
import api from '@/api/allApi'
import Table from '@/components/table.vue'
import globalsets from '@/utils/globalsets'

import ws from '../../websocket/index'

import f10ApiHk from "@/api/f10ApiHk"
export default defineComponent({
  props: {
    token: {
      type: String,
      default: () => {
        return ''
      }
    },
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {

      type: String,
      default: () => {
        return ''
      }
    }
  },
  components: { Table, InfoCircleOutlined },
  setup(props, context) {
    const route = useRoute()
    const pageData: any = reactive({
      list: [],
      list2: [],
      tooltip: {},
      overflow: {},
      EndDate: '',
      EndDate1: '',
      getPopupContainer: () => document.querySelector('.zxzbul li'),
      spinning: true,
      lastPrice: null
    })
    const newsIndexDetails = ref<any>(null)
    onMounted(() => {
      const data = {
        data: {
          market: route.query.market || 'HK',
          symbol: route.query.code || '00700'
        },
        headers: { token: props.token || 'default_token' }
      }
      f10ApiHk.getBriefDetail(data).then((res: any) => {
        newsIndexDetails.value = res?.data.newsIndexDetail
        pageData.spinning = false
      }).catch((error) => {
        console.error('获取数据失败:', error)
        pageData.spinning = false
      })

    })
    // 使用 ref 而不是 computed，避免异步数据问题
    const list = ref<any[]>([])

    // 监听 newsIndexDetails 变化，更新 list
    watch(newsIndexDetails, (newValue) => {
      if (newValue) {
        list.value = setlist()
      }
    }, { immediate: true })
    // 工具函数
    // 报告类型映射函数
    function getReportTypeName(reportType: any): string {
      if (reportType === null || reportType === undefined) return '未知报告'

      const typeMap: { [key: number]: string } = {
        1: '一季报',
        2: '中报',
        3: '三季报(累积)',
        4: '年报'
      }

      return typeMap[reportType] || reportType
    }

    // 币种映射函数
    function getCurrencyName(currencyCode: string): string {
      const currencyMap: { [key: string]: string } = {
        'CNY': '人民币元',
        'HKD': '港元',
        'USD': '美元',
        'EUR': '欧元',
        'GBP': '英镑',
        'JPY': '日元'
      }

      return currencyMap[currencyCode] || '人民币元'
    }

    function formatNumber(value: any, type: string = 'default') {
      // 空值处理
      if (value === null || value === undefined || value === '') return '—'

      const num = Number(value)
      if (isNaN(num)) return '—'

      switch (type) {
        case 'decimal2':
          return num.toFixed(2)

        case 'decimal4':
          return num.toFixed(4)

        case 'unit': {
          if (Math.abs(num) >= 1e12) return (num / 1e12).toFixed(2) + '万亿'
          if (Math.abs(num) >= 1e8) return (num / 1e8).toFixed(2) + '亿'
          if (Math.abs(num) >= 1e4) return (num / 1e4).toFixed(2) + '万'
          return num.toFixed(2)
        }
        case 'units': {
          if (Math.abs(num) >= 1e12) return (num / 1e12).toFixed(2) + '万亿'
          if (Math.abs(num) >= 1e8) return (num / 1e8).toFixed(2) + '亿'

          return num.toFixed(2)
        }
        case 'percent':
          return num.toFixed(2) + '%'

        case 'percentWithColor': {
          const pct = num
          return {
            text: pct.toFixed(2) + '%',
            color: pct > 0 ? 'red' : pct < 0 ? 'green' : 'inherit'
          }
        }

        default:
          return num
      }
    }

    function setlist() {
      const d = newsIndexDetails.value || {}
      return [
        { name: '市盈率 (TTM)', num: formatNumber(d.ttm, 'decimal2') },
        { name: '市净率', num: formatNumber(d.marketRate, 'decimal2') },
        { name: '每股收益 (元)', num: formatNumber(d.basicEps, 'decimal2') },
        { name: '每股净资产 (元)', num: formatNumber(d.symbolAssets, 'decimal2') },

        { name: '营业收入 (元)', num: formatNumber(d.revenue, 'unit') },
        { name: '营业收入同比', num: formatNumber(d.revenueYoy, 'percentWithColor'), },
        { name: '总股本 (股)', num: formatNumber(d.totalSymbol, 'units') },
        { name: '归母净利润', num: formatNumber(d.profitAtsopc, 'unit') },

        { name: '归母净利润同比', num: formatNumber(d.profitAtsopcYoy, 'percentWithColor'), },

        { name: '毛利率', num: formatNumber(d.grossProfit, 'percent') },
        { name: '净利率', num: formatNumber(d.cleanProfit, 'percent') },
        { name: '股息支付率', num: formatNumber(d.symbolPaymentRate, 'percent'), },
        { name: '净资产收益率', num: formatNumber(d.roeRate, 'percent') },
        { name: '资产负债率', num: formatNumber(d.assetsLiabilitiesRate, 'percent') },
        { name: '', num: '' }
      ]
    }


    function isoverflow(e: any, index: number) {
      const text = e.target.outerText
      pageData.tooltip[text] = e.currentTarget.scrollWidth > e.currentTarget.clientWidth
      if (pageData.tooltip[text]) {
        pageData.overflow[text + index] = true
      }
    }
    function hidetool(index: number, text: string) {
      pageData.overflow[text + index] = false
    }
    onMounted(() => {
      if (route.query.code && route.query.market) {
        console.log('重新监听===', route.query.code, route.query.market)
        ws.websocket.safeSubscribeDYNA(route.query.code, route.query.market)
        ws.websocket.on('onDYNA', msg => {
          console.log('打印数据====```', pageData.lastPrice)
          const _data = msg.QuoteData
          // 停牌
          if (_data.DynaData[0].InstStatus === 6) {
            pageData.lastPrice = null
          } else {
            if (_data && _data.DynaData && (_data.DynaData || []).length > 0) {
              pageData.lastPrice = _data.DynaData[0].LastPrice || null
              console.log('打印数据====', pageData.lastPrice)
            }
          }
        })
      }
      console.log(pageData.lastPrice, '========')
    })
    onUnmounted(() => {
      ws.websocket.safeUnsubscribeDYNA(route.query.code, route.query.market)
    })

    return {
      ...toRefs(pageData),
      isoverflow,
      hidetool,
      moment: window.moment,
      newsIndexDetails,
      getReportTypeName,
      getCurrencyName,
      setquarter: globalsets.setquarter,

      list,
      getPopupContainer: pageData.getPopupContainer
    }
  }
})
